import { Input } from '@/components/form/Input';
import { HelpText } from '@/components/ui/HelpText';
import { SwitchableSection } from '@/components/ui/SwitchableSection';
import { DEFAULT_MAXIMUM_LATE_PAYMENTS } from '@/env';
import useProductStore from '@/stores/productStore';

export const MaximumLatePayments = () => {
  const lateDays = useProductStore(d => d.payment.maximumLatePayments ?? DEFAULT_MAXIMUM_LATE_PAYMENTS);

  return (
    <>
      <SwitchableSection
        isActive={true}
        className='pb-2'
        title='Cancelar assinatura por atraso'
        description='Encerra automaticamente a assinatura quando o número permitido de atrasos for ultrapassado.'
      >
        <Input id='maximumLatePayments' type='number' name='maximumLatePayments' />
        <HelpText className='text-content-subtitle'>
          Após {lateDays} cobrança{lateDays > 1 ? 's' : ''} consecutivas em atraso, a assinatura será cancelada
          automaticamente.
        </HelpText>
      </SwitchableSection>
    </>
  );
};
